export type Locale = string & ('es' | 'en');

export type Translations = {
  [locale: string]: any; // @todo precise i18n type
  // @todo precise Translations optional fields and those that admit text and explanation
  //   judgement
  //   image, image.text, image.explanation
  //   lines.explanation, lines.detail.${number}, lines.detail.${number}.text, lines.detail.${number}.explanation
};

export type Book = {
  id: string;
  translation: Translations;
};

export type Explanation = { text: string; explanation: string };
// @todo Typed Explanation on book translation elements (image, lines, ...) that admit both a string or an Explanation
export const setting: string = 'Translation';